import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useMutation } from '@tanstack/react-query';

import { vehicleService } from '../../../../application/VehicleService';
import { Route } from '../../../../domain/route/Route';

type UseDeleteAccountResponseProps = ServiceResponse<() => void, Route>;

// Hooks act as 'Adapter' layer.
export const useDeleteAccount = (): UseDeleteAccountResponseProps => {
  const { isLoading, isError, isSuccess, mutate } = useMutation<void, unknown, void>(() =>
    vehicleService.deleteAccount()
  );

  return {
    run: mutate,
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
  };
};
